import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { RiRadioButtonFill } from "react-icons/ri";
import { BsFiletypeDocx, BsFiletypeXlsx, BsFiletypePdf } from "react-icons/bs";

import { AppContext } from "../../Context";
import Popups from "../../components/Pop";
import Fetch, { Loader } from "../../inc/Fetch";
import '../css/SelectSchool.css'
import { Config } from '../../inc/Config';
import { MdOutlineCloudDownload } from 'react-icons/md';

export default function Send() {
    
    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();


    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [loading, setloading] = useState(false);

    return (
        <>
            {loading && <Loader />}
            <Popups style={{maxWidth:500,}}>
                <h1>{t("task_attached_files")} ({location?.state?.papers?.length})</h1>

                <div className='popupBody ' style={{padding:20}}>
                    {location?.state?.papers?.length ? <table style={{backgroundColor:"#fff"}} className='table attached'>
                        <thead>
                            <tr>
                                <td style={{width:80}}>{t("file")}</td>
                                <td className='text-right'>{t("title")}</td>
                            </tr>
                        </thead>

                        <tbody>
                            {location?.state?.papers?.map((v, k) => {
                                

                                let ext = v?.file?.split(".")?.pop();

                                let FileIco = () => <MdOutlineCloudDownload className='attachIco' />;
                                if (ext == "doc" || ext == "docx") {
                                    FileIco = () => <BsFiletypeDocx className='attachIco' />
                                } else if (ext == "xls" || ext == "xlsx") {
                                    FileIco = () => <BsFiletypeXlsx className='attachIco' />
                                } else if (ext == "pdf") {
                                    FileIco = () => <BsFiletypePdf className='attachIco' />
                                }

                                return (
                                    <tr key={k}>
                                        <td><a target='_blank' href={Config?.imgUrl + v?.file}><FileIco /></a></td>
                                        <td className='text-right'><a style={{color:"#444", fontSize:13}} target='_blank' href={Config?.imgUrl + v?.file}>{v?.title}</a></td>
                                    </tr>
                                );
                            })}
                            
                        </tbody>
                    </table>: false}
                    
                </div>


            </Popups>
        </>
    )
}
